import { logger, monitorClient, performanceTimeline, userAgentParser } from '@soluto-home-web/platform-utils';
import { RouteComponentProps, withRouter } from 'react-router';
import { withTweekKeys } from 'react-tweek';
import { compose } from 'recompose';
import { lifecycle } from 'recompose';
import { Observable } from 'rxjs';
import { defer } from 'rxjs/observable/defer';

type OutterProps = {
  pageName: string;
};

type InnerProps = RouteComponentProps<any> & { reportPagePerformance: boolean };

const writeMetrics = async (pageName: string, metricName: string, duration: number): Promise<void> => {
  const osName: string = userAgentParser.getOs().replace(/ /g, '');
  const browserName: string = userAgentParser.getBrowserName().replace(/ /g, '');

  await monitorClient.updateValue(`${pageName}_${osName}_${browserName}_${metricName}`, duration);
};

const firstPaintMarkObservable = () => {
  return defer(() => Observable.of(performanceTimeline.getLastMeasurement('first-paint')))
    .delay(300)
    .repeat(5)
    .filter((x) => x !== null)
    .take(1);
};

const writePageMeasurementMetrics = async (pathname: string, pageName: string): Promise<void> => {
  try {
    const isManualMeasurementStarted = performanceTimeline.isMeasurementStarted(pathname);

    if (isManualMeasurementStarted) {
      const currentPageMeasurement: PerformanceEntry | null = performanceTimeline.endMeasurement(pathname, pageName);

      if (currentPageMeasurement == null) {
        return;
      }
      await writeMetrics(pageName, 'time-to-component-mount', currentPageMeasurement.duration);
    } else {
      firstPaintMarkObservable().subscribe(async (firstPaintMeasurement: PerformanceEntry) => {
        await writeMetrics(pageName, 'first-paint', firstPaintMeasurement.startTime + firstPaintMeasurement.duration);
      });
    }
  } catch (ex) {
    logger.warn('withPageMeasurement: exception occured while tring to measure page performance', ex);
  }
};

export default compose<InnerProps, OutterProps>(
  withRouter,
  withTweekKeys({ reportPagePerformance: 'soluto_home_web/metrics/report_page_performance' }),
  lifecycle<OutterProps & InnerProps, { unsubscribeMetricsWriter: any }>({
    componentDidMount() {
      if (!this.props.reportPagePerformance || !window.performance) {
        return;
      }

      writePageMeasurementMetrics(this.props.location.pathname, this.props.pageName);
    },
  })
);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/behaviors/withPageMeasurement.ts